module.exports = __webpack_public_path__ + "media/images/achivement-29561e45868fe4ad451f77f41f0faeef.svg";